import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { REQUIREMENTS } from './constants';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { fieldTypes } from 'src/app/constants/constant';
import { HOME_STRING } from 'src/app/modules/dashboard/constants/home-strings.constant';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { appRoutingUrl } from 'src/app/enums/comman.enums';
import { AUTH_CONSTANTS } from '@modules/auth/constants/authConstants';
@Component({
  selector: 'app-creator-requirements-modal',
  templateUrl: './creator-requirements-modal.component.html',
  styleUrls: ['./creator-requirements-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreatorRequirementsModalComponent implements OnInit {
  @Input() isCreatorsHomePage: Boolean = false;

  @ViewChild('creatorRequirementsModal') creatorRequirementsModal;
  consts = REQUIREMENTS;
  AUTH_CONTANTS = AUTH_CONSTANTS;

  isChecked = false;
  consentForm: UntypedFormGroup;
  consentCheckbox = {
    type: fieldTypes.CHECKBOX,
    label: '',
    placeholder: '',
    name: HOME_STRING.CONSENT,
    class: 'col-12',
    options: [
      {
        label: '',
        value: ''
      }
    ]
  };
  constructor(
    public readonly commonService: CommonService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    if (this.commonService.isBrowser) {
      this.consentForm = this.fb.group({
        consent: new UntypedFormControl([])
      });
    }
  }
  openModal() {
    this.consentForm.get('consent').setValue(false);
    this.isChecked = false;
    this.cdr.detectChanges();
    this.creatorRequirementsModal?.openModal();
  }

  closeModal() {
    this.creatorRequirementsModal?.closeModal();
  }

  openLink(url: string) {
    this.commonService.openUrl(environment.websiteURL + url);
  }

  navigate() {
    if (!this.isChecked) return;
    this.closeModal();
    this.router.navigate([appRoutingUrl.BECOME_A_CREATOR]);
  }

  onRequirementContinue() {
    if (!this.isChecked) return;
    this.closeModal();
    this.router.navigate(['auth/creators-signup'])
  }
}
